(() => {
  const html = document.documentElement;
  const bar = document.querySelector('.pm-desktop-nav__bar');
  const drawer = document.querySelector('#site-mobile-nav[data-pm-approved-menu]');
  const toggle = document.querySelector('[data-menu-toggle]');
  if (!bar || !drawer || !toggle) return;
  let frame, open = false, oldOverflow = '';
  function close(focus = false) {
    if (!open) return;
    open = false;
    drawer.dataset.open = 'false';
    drawer.querySelector('[data-mobile-nav-panel]').setAttribute('data-animation-state', 'closed');
    html.classList.remove('pm-mobile-nav-open');
    document.body.style.overflow = oldOverflow;
    toggle.setAttribute('aria-expanded', 'false');
    if (focus) toggle.focus({preventScroll:true});
  }
  function measure() {
    const groups = [...bar.querySelectorAll(':scope > ul')];
    const gap = parseFloat(getComputedStyle(bar).columnGap) || 0;
    const needed = groups.reduce((sum, group) => sum + group.scrollWidth, 0) + gap * Math.max(0, groups.length - 1);
    const compact = innerWidth >= 1024 && needed > bar.getBoundingClientRect().width + 2;
    if (!compact) close();
    html.classList.toggle('pm-nav-compact', compact);
    if (compact) drawer.style.removeProperty('pointer-events');
    toggle.setAttribute('aria-controls', drawer.id);
  }
  function schedule() { cancelAnimationFrame(frame); frame = requestAnimationFrame(measure); }
  window.addEventListener('click', event => {
    if (!html.classList.contains('pm-nav-compact')) return;
    if (event.target.closest('[data-menu-toggle]')) {
      event.preventDefault(); event.stopImmediatePropagation();
      if (open) { close(true); return; }
      open = true; oldOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      drawer.dataset.open = 'true';
      drawer.querySelector('[data-mobile-nav-panel]').setAttribute('data-animation-state', 'open');
      html.classList.add('pm-mobile-nav-open');
      toggle.setAttribute('aria-expanded', 'true');
    } else if (open && event.target.closest('[data-mobile-nav-close], [data-mobile-nav-overlay]')) {
      event.preventDefault(); event.stopImmediatePropagation(); close(true);
    }
  }, true);
  window.addEventListener('keydown', event => { if (open && event.key === 'Escape') { event.preventDefault(); close(true); } }, true);
  new ResizeObserver(schedule).observe(bar);
  new MutationObserver(schedule).observe(bar, {childList:true,subtree:true,characterData:true});
  window.addEventListener('resize', schedule);
  document.addEventListener('shopify:section:load', schedule);
  if (document.fonts) document.fonts.ready.then(schedule);
  measure();
})();
